import { get } from "lodash";
import * as UserServices from "../../helpers/services/UserServices";
import * as ContractServices from "../../helpers/services/ContractServices";
import ContractActionTypes from "../contract/contract.types";
import { receiveErrors, clearErrors } from "../error/error.actions";
import UserActionTypes from "./user.types";
import { setAuthCookie } from "../../helpers/utils/cookie";
var CryptoJS = require("crypto-js");

const setCurrentUser = (user) => ({
  type: UserActionTypes.SET_CURRENT_USER,
  payload: user,
});

const setPaymentTerms = (payment) => ({
  type: ContractActionTypes.PAYMENT_TERMS,
  payload: payment,
});

const setBrandDetails = (brands) => ({
  type: ContractActionTypes.BRAND_DETAILS,
  payload: brands,
});

export const setOriginalPath = (path) => ({
  type: UserActionTypes.SET_ORIGNAL_PATH,
  payload: path,
});
const logoutCurrentUser = () => ({
  type: UserActionTypes.LOGOUT_CURRENT_USER,
  payload: { isSessionValid: false },
});

const setSessionValidated = (isSessionValid) => ({
  type: UserActionTypes.SET_SESSION_VALIDATED,
  payload: { isSessionValid },
});

export const signup = (user) => async (dispatch) => {
  const response = await UserServices.signup(user);

  if (response.status === 200) {
    return dispatch(setCurrentUser(response.data));
  }
  return dispatch(receiveErrors(response.data));
};

export const login = (user) => async (dispatch) => {
  try {
    dispatch(clearErrors());
    user["password"] = CryptoJS.SHA1(user.password).toString(
      CryptoJS.enc.Base64
    );
    const response = await UserServices.login(user);
    setAuthCookie(get(response, "esid"));
    dispatch(setSessionValidated(true));
    const userInfo = await UserServices.getUserInfo();
    const brandDetails = await ContractServices.getBrandDetails();
    const paymentTerms = await ContractServices.getPaymentTerms();
    dispatch(setPaymentTerms(paymentTerms));
    dispatch(setBrandDetails(brandDetails));
    return dispatch(setCurrentUser(userInfo));
  } catch (error) {
    dispatch(setSessionValidated(false));
    return dispatch(receiveErrors(error));
  }
};

export const logout = () => async (dispatch) => {
  const response = await UserServices.logout();
  dispatch(logoutCurrentUser());
  if (response.status === 200) {
    return dispatch(logoutCurrentUser());
  }
  return dispatch(receiveErrors(response.data));
};

export const getUserInfo = () => async (dispatch) => {
  const response = await UserServices.logout();

  if (response.status === 200) {
    dispatch(setSessionValidated(true));
    return dispatch(logoutCurrentUser());
  }
  return dispatch(receiveErrors(response.data));
};
